import React, { useRef, useEffect } from "react";
import "C:/Users/yrsha/client1/src/page/About.js";
import Mr_Raj from 'C:/Users/yrsha/client1/src/assets/Mr_Raj.jpg';
import TeamImage from 'C:/Users/yrsha/client1/src/assets/team.jpg';


const About = () => {
  return (
    <div className="about-page">
      {/* About Us Section */}
      <section className="about-section py-5 fade-in">
        <div className="container">
          <h1 className="section-heading">ABOUT US</h1>
          <p className="section-description">
          Established in 1993, TAAS Elect. Motor Winding Services is a privately-owned business with over 30 years of experience in the Middle East providing a complete solution for all your engineering needs from services in the range of electromechanical engineering.
<p></p>
<br></br>TAAS Elect. Motor Winding Services is the first choice among corporates for its reliability in high precision field of Electric Motors, Submersible Pumps, Generators, Compressors and Transformers. Whether they are small or large, rewinding AC / DC electric motor (and rotors) is more than just a service, it is a craft.  
<p></p>
<b></b>Highly skilled craftsmen are vital to every step of the rewind process. With a low turnaround time for our services, we ensure the motors are back to normal self with in no time hence increasing the productivity for our customers. 
          </p>

          <div className="row align-items-center mt-5">
            {/* Left: Founder Image */}
            <div className="col-lg-5 text-center">
              <div className="founder-img-container slide-in-left">
                <img src={Mr_Raj} alt="Mr. Raj Sharma" className="founder-image"
                loading="lazy"  />
              </div>
            </div>

            {/* Right: Founder Description */}
            <div className="col-lg-7 text-container slide-in-right">
              <h5 className="founder-name">Mr. Raj Sharma</h5>
              <p className="founder-text">
              Raj is the visionary founder of a dynamic startup specializing in innovative motor winding solutions. With a passion for engineering excellence and a commitment to quality, he leads a team dedicated to delivering efficient, reliable, and tailored services. Under his leadership, the company is revolutionizing the industry by combining expertise with cutting-edge technology to meet diverse client needs.
              </p>

              {/* Contact Info */}
              <p>
                <a href="tel:+971527499912" className="contact-link">
                  +971-52749-9912
                </a> | 
                <a href="mailto:raj@taasengg.com" className="contact-link">
                  raj@taasengg.com
                </a>
              </p>

              {/* Social Media Links */}
              <p>
                <a href="#" className="social-link">Instagram</a> | 
                <a href="#" className="social-link">Facebook</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
      <section className="team-section py-5 fade-in">
        <div className="container">
          <div className="row align-items-center">
            {/* Left: Text Content */}
            <div className="col-md-6 slide-in-left">
              <h5 className="team-heading">Meet My Team</h5>
              <p className="team-description">
              Meet the dedicated professionals behind Taas Services – skilled engineers, technicians, and experts committed to excellence in motor winding and engineering solutions. With years of experience, our team ensures every project meets the highest standards of quality, precision, and reliability. We embrace innovation, teamwork, and continuous learning to adapt to industry demands and provide tailored solutions. From electrical rewinding to industrial support, we take on challenges with expertise and passion, driving success one solution at a time.
              </p>
            </div>

            {/* Right: Image */}
            <div className="col-md-6 text-center slide-in-right">
              <img src={TeamImage} alt="Team" className="team-image img-fluid" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

